import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// HTTPS enforcement in production
if (process.env.NODE_ENV === 'production' && window.location.protocol !== 'https:') {
  window.location.href = window.location.href.replace('http:', 'https:');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
